module.exports = __webpack_public_path__ + "img/rlcj.2ef50834.png";